import { create } from 'zustand';
import { MessageCentreStoreType } from '../../Types/MessageCentreStoreTypes';
import MessageCentreReducer from '../Reducers/MessageCentreReducers';
import { defaultMessageCentreData } from '../Data/MessageCentreData';

const useMessageCentreStore = create<MessageCentreStoreType>((set) => ({
	...defaultMessageCentreData,
	dispatchMessageCentreStoreUpdate: (action) => set((state) => MessageCentreReducer(state, action)),
}));

export { useMessageCentreStore };
